import { createGlobalState } from '@vueuse/core';
import { getCookie, deleteCookie, setCookie } from '~/logic/helpers/cookies.js';

const SAPPHIRE_COOKIE = 'sapphire-amal';
const cookieConfigs = `;domain=${ window.location.hostname.replace('www', '') };secure;SameSite=Lax`;

export const useAmalAuthStore = createGlobalState(() => {
	const userInfo = ref(null);

	const _getIsLoggedInStatus = () => {
		return getCookie(SAPPHIRE_COOKIE) && userInfo.value;
	};
	const isLoggedIn = ref(_getIsLoggedInStatus());
	const isAuthStateReady = ref(false);

	const saveLoginState = (accessToken) => {
		const d = new Date();
		const numberOfDay = 1 / 24 / 2; // 30 minutes
		d.setTime(d.getTime() + (numberOfDay * 24 * 60 * 60 * 1000));
		const expires = d.toUTCString();
		
		setCookie(SAPPHIRE_COOKIE, accessToken, expires, undefined, cookieConfigs);
	};

	const isSapphireCookiePresent = () => {
		return getCookie(SAPPHIRE_COOKIE);
	};

	const login = async (_userInfo) => {
		userInfo.value = _userInfo;
		refreshAuthStatus();
	};

	const logout = () => {
		deleteCookie(SAPPHIRE_COOKIE, cookieConfigs);
		userInfo.value = null;
		refreshAuthStatus();
	};

	const refreshAuthStatus = () => {
		isLoggedIn.value = _getIsLoggedInStatus();
	};

	return {
		// data
		isLoggedIn,
		userInfo,
		isAuthStateReady,

		// method
		saveLoginState,
		login,
		logout,
		refreshAuthStatus,
		isSapphireCookiePresent,
	};
});
